<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="naam">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Naam </th>
        <td mat-cell *matCellDef="let row"> {{row.naam}} </td>
    </ng-container>
	
	<ng-container matColumnDef="afdeling">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Afdeling </th>
        <td mat-cell *matCellDef="let row"> {{row.afdeling}} </td>
    </ng-container>

	<ng-container matColumnDef="functie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Functie </th>
        <td mat-cell *matCellDef="let row"> {{row.functie}} </td>
    </ng-container>
	
    <ng-container matColumnDef="actief">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Actief </th>
        <td mat-cell *matCellDef="let row"> <mat-icon *ngIf="row.actief">done</mat-icon></td>
    </ng-container>
</mg-table>
